// Pure presentation helpers for the Job Detail "Time" card (migration 0056).
// No I/O; unit-tested in time-entry-format.test.ts.

import type { ProductLine, TimeEntry } from '@gutterinv/shared';

/** Footage unit label by product line: gutter is billed per LINEAR foot,
 *  insulation per SQUARE foot. Labels the "Actual installed footage" field. */
export function footageUnitLabel(productLine: ProductLine): 'LF' | 'SF' {
  return productLine === 'insulation' ? 'SF' : 'LF';
}

/** Human-readable product-line label (the "Type of job" row in the
 *  Customer & Site card). */
export function productLineLabel(productLine: ProductLine): 'Gutter' | 'Insulation' {
  return productLine === 'insulation' ? 'Insulation' : 'Gutter';
}

/** Sum travel hours across a set of entries (card footer total). Rounded to
 *  2 decimals to avoid float drift (e.g. 0.1 + 0.2). install_hours dropped in
 *  migration 0057. */
export function totalHours(entries: TimeEntry[]): { travel: number } {
  let travel = 0;
  for (const e of entries) {
    travel += e.travelHours;
  }
  return {
    travel: Math.round(travel * 100) / 100,
  };
}

/** Compact "Xh" hours label for a cell (drops a trailing .0 → "8h" not "8.0h"). */
export function formatHours(h: number): string {
  return `${Number(h.toFixed(2))}h`;
}
